module.exports = __webpack_public_path__ + "img/2.90238e8f.png";